// Keeps "Couleur : Noir" style legends in sync with the selected variant option.
document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

  const fieldset = input.closest('variant-radios fieldset');
  const output = fieldset && fieldset.querySelector('[data-vd-selected-value]');
  if (output) output.textContent = input.value;
});
